module.exports = __webpack_public_path__ + "media/images/ask-cindy-inner-0f63d69267de8d5b89d323f9c4c0b31d.png";